import classNames from 'classnames';
import { CollapsableText } from '../../CollapsableText';
import React from 'react';
import styles from '../styles.module.scss';

interface PropTypes {
  summary: string;
  classNames: string;
}

export function CollapsableSummaryPanel(props: PropTypes) {
  return (
    <>
      <div className='fs-5 fw-bold'>Summary</div>
      <div
        className={classNames(
          props.classNames,
          'bg-gray',
          'fs-5',
          'py-2',
          'px-3',
          'rounded-2',
          styles.summary,
        )}
      >
        <CollapsableText
          collapseWords={50}
          maxWords={350}
          expandWordsStep={100}
          text={props.summary}
        />
      </div>
    </>
  );
}
